module.exports = __webpack_public_path__ + "static/mobalum2-59245ca7097ee6978618a74101821870.png";